import { render, staticRenderFns } from "./tutorInTheAssessment.vue?vue&type=template&id=9cf32672&scoped=true&"
import script from "./tutorInTheAssessment.vue?vue&type=script&lang=js&"
export * from "./tutorInTheAssessment.vue?vue&type=script&lang=js&"
import style0 from "./tutorInTheAssessment.vue?vue&type=style&index=0&id=9cf32672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf32672",
  null
  
)

export default component.exports